import React from 'react';
import { Link } from "react-router-dom";
import {
  Grid,
  Segment,
} from 'semantic-ui-react';
import Button from '@material-ui/core/Button';
import './App.css';

//import server_config from './serverconfig';
//const node_address = server_config["node_address"];

const HomePage = ({ formState, changeFormState }) => {

  //const history = useHistory();

  /*
  const submitSignUp = () => {
    const body = {
      "displayname": formState.displayname,
      "youtubechannelurl": formState.youtubechannelurl,
      "wanttobeinvideo": true,
      "captchatoken": formState.captchatoken
    };
    axios({
      method: 'POST',
      //url: 'https://evidence.report' + ':' + '3003' + '/',
      url: node_address,
      timeout: 5000,
      data: body,
    }).then((resp) => {
      if (resp.data.success) {
        changeFormState(true, "submitted");
      } else {
        alert("Something went wrong! Please contact Khalid at: KhalidShahinIP@gmail.com");
      }
    })
      .catch(err => {
        alert("Something went wrong! Please contact Khalid at: KhalidShahinIP@gmail.com");
        console.log(err);
      });
  }
  */

  /*
  const onCaptchaChange = (value) => {
    changeFormState(value, "captchatoken");
  }
  */

  return (
    <Grid style={{ margin: 0 }}>
      <Grid.Column align="center" style={{ padding: 0 }}>
        <div className="evidence-home">
          <header className="App-header siteTitle" style={{ textAlign: "center" }}><h1 style={{ fontSize: "36px", paddingBottom: "0px" }}>Evidence.Report</h1></header>
          <>
            <div className="evidence-layout">
              <section className="evidence-panel summary-panel">
                <div className="panel-heading">
                  {/*<h2>Summary of Recent Projects</h2>*/}
                  <p>
                    GitHub:{" "}
                    <a
                      href="https://github.com/Khalid-Shahin"
                      target="_blank"
                      rel="noreferrer"
                    >
                      github.com/Khalid-Shahin
              </a>
                  </p>
                </div>

                <div className="project-summary-grid">
                  <article className="summary-block programming-block">
                    <h3>About Me</h3>
                    <ul>
                      <li>Full-stack developer</li>
                      <li>Co-creator of EBMonFHIR<sup>&reg;</sup> since 2018</li>
                      <li>
                        Created programs that use the National Library of
                        Medicine APIs (PubMed, RxNav, etc)
                </li>
                      <li>EHR integration with FHIR<sup>&reg;</sup> support</li>
                      <li>Senior software engineer at Computable Publishing (<a style={{ fontSize: "14px", fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace' }} href="https://fevir.net" target="_blank" rel="noopener noreferrer">FEvIR.net</a>)</li>
                    </ul>
                  </article>

                  <article className="summary-block fhir-block">
                    <h3>
                      FHIR<sup>&reg;</sup> Committer Work
              </h3>
                    <ul>
                      <li>
                        Evidence-Based Medince Resources (Evidence, EvidenceVariable,
                        PublicationRecord, ArtifactAssessment)
                </li>
                      <li>
                        HL7<sup>&reg;</sup> Structured Documents Working Group Co-Chair (Composition Resource)
                </li>
                      <li>
                        FHIR<sup>&reg;</sup> Committer for 3 Work Groups (Clincical Decision Support, Structured Documents, Biomedical Research &amp; Regulation)
                </li>
                    </ul>
                  </article>

                  <article className="current-work-block">
                    <h3>Currently Working On</h3>
                    <ul>
                      <li>Turning unstructured data into structured FHIR<sup>&reg;</sup> Resources</li>
                      <li>Transforming FHIR<sup>&reg;</sup> Resources between different release versions (e.g. R4 and R6)</li>
                      <li>Automatically identifying eligibility criteria and making it FHIR<sup>&reg;</sup> format</li>
                      <li>Exchanging Hematology and Oncology information using FHIR<sup>&reg;</sup></li>
                      <li>Bringing scientific research to clinical practice</li>
                    </ul>
                  </article>

                </div>
              </section>

              <section className="applications-panel">
                <div className="panel-heading applications-heading">
                  <h2>Projects</h2>
                </div>
                <div style={{ width: "100%", textAlign: "center", padding: "22px" }}>
                  <Button component="a" href="https://Evidence.ICU" rel="noopener noreferrer" variant="contained" color="primary" size="large" size="large" style={{ width: "330px", maxWidth: "100%" }}>
                    <h3>Evidence.ICU FHIR<sup>&reg;</sup> PROJECTS</h3>
                  </Button>
                  <br />
                  <br />
                  <Button component={Link} to="/wordchaser" variant="contained" color="primary" size="large" size="large" style={{ width: "330px", maxWidth: "100%" }}>
                    <h3>Word Chaser</h3>
                  </Button>
                  <br />
                  <br />
                  <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    gap: "10px"
                  }}>
                    <div style={{ width: "185px", height: "1px" }} className="mobile-hidden" />
                    <Button component="a" href="/gravity.html" variant="contained" color="primary" size="large" size="large" style={{ width: "330px", maxWidth: "100%" }}>
                      <h3>Simple Gravity Simulation</h3>
                    </Button>
                    <Button component={Link} to="/gravity" variant="contained" color="secondary" size="large" style={{ paddingLeft: "8px", paddingRight: "8px" }}>
                      <h3 style={{ display: "inline", margin: "0px" }}>&nbsp;</h3>
                      <span style={{ fontSize: "11px" }}>(Original Python Version)</span>
                      <h3 style={{ display: "inline", margin: "0px" }}>&nbsp;</h3>
                    </Button>
                  </div>
                </div>
              </section>
            </div>
            {/*<br className={`unselectable`} />*/}
            <div className={`bottomSegment`}>
              {/*<Link to="/"><Segment className={`bottomSegment unselectable`} inverted raised onClick={() => { }}>
              <h2>Back</h2>
            </Segment></Link>*/}
            </div>
          </>
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default HomePage;